import translations from '../../../translations/app-translations.json';
import Actions from '../../actions';

export const addProductToCartNotifyEP = (locale, error, toastr) => {
    if ((error && error.response && error.response.body)
        && (error.response.body.error.indexOf('is not available.') > -1 || error.response.body.error.indexOf('no está disponible.') > -1)) {
        toastr.error(translations[locale].error, translations[locale]['sorry-out-of-stock']);
    } else if (error && error.response && error.response.body && error.response.body.error) {
        toastr.error(translations[locale].error, error.response.body.error);
    } else {
        toastr.error(translations[locale]['error-create-order-title'], translations[locale]['error-create-order-content']);
    }
};

export const addProductToCartNextActionEP = (dispatch, order, locale, userToken = null) => {
    if (order.line_items.length > 0) {
        dispatch(Actions.addingProductToCart());
    } else {
        dispatch(Actions.emptyCart(order, locale, userToken));
    }
};



/** WEBPACK FOOTER **
 ** ./src/errors/processors/add-product-to-cart.js
 **/